//@service

import {RepositoryInterface, bind} from '@/service/utils'

export const azmoonService= {
  get azmoonRepository() {
    return bind(() => import('./azmoon.repo'), RepositoryInterface);
  },
  get questionsTitleRepository() {
    return bind(() => import('./questionsTitle.repo'), RepositoryInterface);
  },
  get questionsOptionRepository() {
    return bind(() => import('./questionsOption.repo'), RepositoryInterface);
  },
  get questionRepository() {
    return bind(() => import('./question.repo'), RepositoryInterface);
  },
  get examPackQuestionRepository() {
    return bind(() => import('./examPackQuestion.repo'), RepositoryInterface);
  },
  get examPackRepository() {
    return bind(() => import('./examPack.repo'), RepositoryInterface);
  },
  get optionRepository() {
    return bind(() => import('./option.repo'), RepositoryInterface);
  },
  get titleRepository() {
    return bind(() => import('./title.repo'), RepositoryInterface);
  },
  get azmoonExecuteRepository() {
    return bind(() => import('./azmoonExecute.repo'), RepositoryInterface);
  },
  get azmoonExecutePersonRepository() {
    return bind(() => import('./azmoonExecutePerson.repo'), RepositoryInterface);
  },
  get azmoonExecuteExamPackRepository() {
    return bind(() => import('./azmoonExecuteExamPack.repo'), RepositoryInterface);
  },
  get azmoonExecuteExamPackQuestionsRepository() {
    return bind(() => import('./azmoonExecuteExamPackQuestions.repo'), RepositoryInterface);
  },
  get azmoonExecuteExportRepository() {
    return bind(() => import('./azmoonExecuteExport.repo'), RepositoryInterface);
  },
  get reportSettingsRepository() {
    return bind(() => import('./reportSettings.repo'), RepositoryInterface);
  },
  get azmoonExecuteReportRepository() {
    return bind(() => import('./azmoonExecuteReport.repo'), RepositoryInterface);
  },
  get analysisAlgorithmRepository() {
    return bind(() => import('./analysisAlgorithm.repo'), RepositoryInterface);
  },
  get analysisAlgorithmComponentRepository() {
    return bind(() => import('./analysisAlgorithmComponent.repo'), RepositoryInterface);
  },
  
}

